import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import { NMTipoDocumento } from "../shared/Denominaciones";
import Paginador from "./components/Paginador";
import { ValidarNumLtr } from "../shared/Regex";

export default function Conductores(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaConductores, setListaConductores] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroConductor, setFiltroConductor] = useState("");

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);
    //#endregion

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerListaConductores("",1);
    },[]);

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE CONTENIDO
    const HandlerListaConductores = (valor) => setListaConductores(valor);
    // ESTADOS DE FILTRO
    const HandlerFiltroConductor = (valor) => {
        if(ValidarNumLtr(valor) || valor == ""){
            setFiltroConductor(valor.toUpperCase());
        }
    }
    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);
    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    const ObtenerListaConductores = async(conductor, pagina) => {
        const paramConductor = conductor == "" ? "-" : conductor;
        try{
            const response = await axios.get(URL_LISTAR_CONDUCTORES,{
                headers: HEADERS_API,
                params: {
                    fConductor: paramConductor,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });
            HandlerListaConductores(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }

    // FUNCIONES COMPLEMENTARIAS
    const QuitarFiltros = () => {
        HandlerFiltroConductor("");
        ObtenerListaConductores("", 1);
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaConductores(filtroConductor, pagina);
    }
    
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>CONDUCTORES</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-conductor"}>
                    <button className="btn btn-primary">Nuevo Conductor</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-10 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroConductor(e.target.value)} value={filtroConductor} maxLength={50} type="text" className="form-control" placeholder="Buscar" id="filtro-transportista" autoComplete="off"/>
                    <label htmlFor="filtro-transportista">Buscar</label>
                </div>
            </div>
            <div className="col-12 col-md-2">
                <button onClick={e=>ObtenerListaConductores(filtroConductor, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Tipo Documento</th>
                            <th>N° Documento</th>
                            <th>Nombre</th>
                            <th>Licencia</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaConductores.length > 0 ? listaConductores.map((item, index) => (
                                <tr key={index}>
                                    <td>{NMTipoDocumento(item.tipoDoc)}</td>
                                    <td>{item.nroDoc}</td>
                                    <td>{item.nombre}</td>
                                    <td>{item.nroLicencia}</td>
                                    <td>
                                        <Link to={`/detalle-conductor/${item.nroDoc}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_CONDUCTORES = process.env.REACT_APP_URL_LISTAR_CONDUCTORES
//#endregion